import { cx } from '@twind/core';

export default function TailorPDFTag({ className }: { className?: string }) {
  return (
    <span
      id="ostro-tailor-pdf-tag"
      className={cx('~(py-[2px] px-[6px] bg-tag rounded-[32px] ml-2 text-xs font-semibold)', className)}
    >
      PDF
    </span>
  );
}
